import { useEffect, useState } from "react";
import { supabase } from "./App";
import { filter as f,map as m,compose as C,omit,propEq, pickBy, isNotEmpty, isNil, reject, groupBy as g, prop as p, defaultTo, tap, values, partition, has} from "ramda";
import "./add_questions.css";
import { ColorPicker } from "./colorPicker";

const createScale = (size) => Array.from({ length: size }, (_, i) => {
    const value = i - Math.floor(size / 2);
    return { value, color: "#eeeeee", text: value.toString() };
})
const emptyChoice = value => ({ text: "", color: "#eeeeee" ,value});

const EditForm = ({question_choices,scale_values,id,type: initial_type,setQuestions,questions,
  text: initial_text,shortname: initial_shortname,event_id,min,max,min_color,max_color}) => {

    const [choices, setChoices] = useState(question_choices || [emptyChoice(1),emptyChoice(2)]);
    const [scaleValues, setScaleValues] = useState(scale_values || createScale(3));
    const [type, setType] = useState(initial_type === "new" ? "number" : initial_type);
    const [text, setText] = useState(initial_text || "");
    const [minMax, setMinMax] = useState([
      {value:min,color:min_color || "#eeeeee", text:"min"},
      {value:max,color:max_color|| "#eeeeee",text:"max"}]); 
    const [shortname, setName] = useState(initial_shortname || "");

  const changeScale = (e) => {
    const size = parseInt(e.target.value) * 2 + 1;
    const newScale = createScale(size);
    const diff = size-scaleValues.length;
    const joined = scaleValues.length === size ? scaleValues : 
        diff > 0 ? [...newScale.slice(0,diff/2),...scaleValues,...newScale.slice(-diff/2)] : 
        scaleValues.slice(-diff/2, diff/2); 
    setScaleValues(joined);
  }

  const save_changes = (id) => async (e) => {
    e.preventDefault();
    const [{color:min_color, value: min},{color:max_color, value: max}] = minMax;

    if (id === "new") {
      const inserted = await supabase
        .from("questions")
        .insert(omit(isNil,{shortname,text,type,event_id,min,max,min_color,max_color}))
        .select("*")
        .single();  

      if ((type === "nominal" || type === "scale") && inserted.data?.id) {
        const new_choices = await supabase
          .from("question_choices")
          .upsert(m(x => ({...x, question_id: inserted.data.id, type}),type === "nominal" ? choices : scaleValues))
          .select("*")
        if(new_choices.data?.length) (type === "nominal" ? setChoices : setScaleValues)(new_choices.data);
      }
    } else {
      const updated = await supabase
        .from("questions")
        .upsert(omit(isNil,{shortname,text,type,event_id,id,min,max,min_color,max_color}))
        .select("*")
        .single();  
    }
    if (type === "nominal" || type === "scale") {

      const [updatable,addable] = C(
        partition(has("id")),
        m(x => ({...x, question_id: id, type}))
      )(type === "nominal" ? choices : scaleValues);

      let updated = { data: [] };
      if (updatable.length) {
        updated = await supabase
          .from("question_choices")
          .upsert(updatable.sort((a,b) => a.value-b.value).map((x,n) => ({...x,value:n+1})), { onConflict: "id" })
          .select("*");
      }
      let added = { data: [] };
      if (addable.length) {
        added = await supabase
          .from("question_choices")
          .insert(addable)
          .select("*");
      }
      (type === "nominal" ? setChoices : setScaleValues)([...(updated.data || []),...(added.data || [])]);
    }
    const change_updated = await supabase.from("events").update({ updated: true }).eq("play",true);
  };

  const delete_question = id => async () => {
    const deleted = await supabase
      .from("questions")
      .delete()
      .eq("id",id)

    if (deleted.status === 204) setQuestions(reject(propEq(id,"id"),questions))
  }

  const delete_choice = (id) => async () => {
    const deleted = await supabase
      .from("question_choices")
      .delete()
      .eq("id",id)
    if (deleted.status === 204) setChoices(reject(propEq(id,"id"),choices));
    const updated_order = await supabase
      .from("question_choices")
      .upsert(reject(propEq(id,"id"),choices).sort((a,b) => a.value-b.value).map((x,n) => ({id:x.id,value:n+1})), { onConflict: "id" })
    const change_updated = await supabase.from("events").update("updated",true).eq("play",true);
  }

  return (
    <form className="add_edit_question" onSubmit={save_changes(id)}>

      <div className="type-radio-group">    
        <label><input type="radio" name="question_type" value={"number"} checked={type === "number"}
            onChange={(e) => setType(e.target.value)}/>numbriline</label>
        <label><input type="radio" name="question_type" value={"scale"} checked={type === "scale"}
            onChange={(e) => setType(e.target.value)}/>skaala</label>
        <label><input type="radio" name="question_type" value={"nominal"} checked={type === "nominal"}
            onChange={(e) => setType(e.target.value)}/>valikvastused</label>
      </div>

      <label>
        <p className="label">nimetus</p>
        <input type="text" onChange={(e) => setName(e.target.value)} value={shortname}/>
      </label>
      <label>
        <p className="label">küsimus</p>
        <textarea onChange={(e) => setText(e.target.value)} value={text}/>
      </label>

      {type === "nominal" && (
        <div className="choices-section">
            {choices.map((choice, idx) => (
                <div key={idx} className="choice-row">
                    <ColorPicker setChoices={setChoices} choices={choices} choice={choice} idx={idx} />
                    <input type="text" value={choice.text} onChange={(e) => {
                        const newChoices = [...choices];
                        newChoices[idx].text = e.target.value;
                        setChoices(newChoices);
                    }}/>
                    <button type="button" onClick={delete_choice(choice.id)}>✖</button>
                </div>
            ))}
            <button type="button" className="add_new" onClick={() => setChoices([...choices, emptyChoice(choices.length+1)])}>+</button>
        </div>
      )}
      {type === "number" && (
        <div className="number-section">
          {minMax.map((x,i) => (<div className="numberrange">
            <label key={x.text} ><p className="label">{x.text}</p><input type="number" value={x.value} onChange={(e) => {
                        const newMinMax = [...minMax];
                        newMinMax[i].value = parseInt(e.target.value);
                        setMinMax(newMinMax);
                    }}/></label>
            <ColorPicker setChoices={setMinMax} choices={minMax} choice={x} idx={i} />
          </div>)
          )}
        </div>
      )}
      {type === "scale" && (
        <>
          <div className="scale-labels">
            <div className="scale-section">
                <label><input type="radio" name="s" value="1" defaultChecked onChange={changeScale}/> -1 kuni 1</label>
                <label><input type="radio" name="s" value="2" onChange={changeScale} /> -2 kuni 2</label>
                <label><input type="radio" name="s" value="3" onChange={changeScale} /> -3 kuni 3</label>
            </div>
            {scaleValues.map((x,i) => (
                <div key={x.value} className="scale-label">
                  <ColorPicker setChoices={setScaleValues} choices={scaleValues} choice={x} idx={i} />
                  <input key={x.value}  placeholder={`${x.value}`} value={x.text} type="text" onChange={(e) => {
                        const newScale = [...scaleValues];
                        newScale[i].text = e.target.value;
                        setScaleValues(newScale);
                    }}/>
                </div>
              ))}
          </div>
        </>
      )}
      <div className={"buttons"}>
        <button className="save_button" type="submit">SALVESTA</button>
        <button className="static delete_button" type="button" onClick={delete_question(id)}>✖</button>
      </div>
    </form>
  );
};

export const Questions = ({ event_id }) => {
  const [questions, setQuestions] = useState([]);
  const [active, setActive] = useState({});

  const fetchQuestions = async () => {
    const { data } = await supabase
      .from("questions")
      .select("*, question_choices(*)")
      .eq("event_id", event_id)
      .order('shortname')

      const formatted = m(
        C(
        pickBy(isNotEmpty),
        x => ({...x,
          question_choices: f(propEq("nominal","type"),x.question_choices),
          scale_values: f(propEq("scale","type"),x.question_choices),
        })
      ),
      data)
    setQuestions([...formatted, { type: "new", id: "new", event_id }]);
  };
  const handleDragStart = (obj) => (e) => {
    e.target.classList.add("dragging");
    e.dataTransfer.setData("application/json", JSON.stringify(obj));
  };

  useEffect(() => {fetchQuestions();}, []);
  const button_class = (x, active) => x.id === "new" ? "add_new" : active?.id !== x.id ? "question" : "";
  return (
    <div className="questions-container">
      <h2>Küsimused</h2>
      <div id="questions">{C(
        m(xs => <div key={xs[0].type}>
            <div className="type-questions">{m((x) => 
              <div key={x.id || "empty"} onClick={() => setActive(x)} 
                draggable={(active?.id !== x.id)} 
                onDragStart={(active?.id !== x.id) ? handleDragStart(x) : null}>
                  {active?.id === x.id ? (<EditForm {...x} setQuestions={setQuestions} questions={questions} />) :  
                  (<button className={button_class(x, active)}>
                    {x.shortname || x.text || "+"}{{scale:" | skaala",nominal:" | valikud",number:" | numbriline",new:""}[x.type]}
                    {x.type !== "new" ? 
                      <div className="color-line">{
                        m(x => <span style={{ backgroundColor: x.color }}></span>, 
                          x.type ==="scale" ? x.scale_values : x.type === "nominal" ? x.question_choices : [])
                        }</div> : null}
                  </button>)}
              </div>,xs || [])}
            </div>
          </div>),
        values,
        g(p("type"))
        )(questions || [])}</div>
      </div>
  );
};
